module.exports = __webpack_public_path__ + "img/star2.43dfc404.png";